const masterMessages = {
  'master.title': 'タグセット管理',
  'master.settings.item.unavailableTag.show': '利用不可タグを表示',
  'master.settings.item.unavailableTag.hide': '利用不可タグを非表示',
  'master.settings.item.csvDownload': 'CSVテンプレートダウンロード',
  'master.settings.item.csv.export': 'CSVエクスポート/インポート',
  'master.MasterLists.item': '階層',
  'master.MasterLists.item.tagSet': 'タグセット',
  'master.MasterLists.unselected': '親階層を選択してください。',
  'master.MasterLists.unavailable': '利用不可',
  'master.EditMasterDialog.title': 'タグ編集',
  'master.EditMasterDialog.title.tagName': 'タグ名称',
  'master.EditMasterDialog.title.tagName.placeholder':
    'タグ名称を入力してください',
  'master.EditMasterDialog.title.configuration.group': 'グループ利用設定',
  'master.EditMasterDialog.title.configuration': '利用設定',
  'master.EditMasterDialog.item.configuration.available': '利用可',
  'master.EditMasterDialog.item.configuration.notAvailable': '利用不可',
  'master.EditMasterDialog.item.tagName.formatError':
    '入力内容に誤りがあります。',
  'master.EditMasterDialog.item.button.cancel': 'キャンセル',
  'master.EditMasterDialog.item.button.delete': '削除',
  'master.EditMasterDialog.item.button.update': '更新',
  'master.EditMasterDialog.item.button.close': '閉じる',
  'master.EditMasterDialog.confirm.message1': '{tag}タグを削除します。',
  'master.EditMasterDialog.confirm.message2':
    '※タグを削除すると紐づくデータにも影響が及びます。',
  'master.OneLayerMasterImportDialog.title': '階層{depth}のインポート',
  'master.TagSetImportDialog.title': 'タグセットのインポート',
  'master.OneLayerMasterImportDialog.message1':
    '階層{depth}のタグをインポートします。',
  'master.TagSetImportDialog.message1': 'タグセットをインポートします。',
  'master.OneLayerMasterImportDialog.message2': 'インポート開始ボタンを押し、',
  'master.OneLayerMasterImportDialog.message3':
    'CSVファイルを選択してください。',
  'master.OneLayerMasterImportDialog.button.import': 'インポート開始',
  'master.MasterImportDialog.title': 'エクスポート/インポート',
  'master.MasterImportDialog.export.button': 'CSVエクスポート',
  'master.MasterImportDialog.export.message1':
    'タグセットの内容をエクスポートし、編集してください。',
  'master.MasterImportDialog.export.message2': 'タグを編集してください。',
  'master.MasterImportDialog.import.button': 'CSVインポート',
  'master.MasterImportDialog.import.message1':
    '編集したタグセットをインポートします。',
  'master.ImportErrorDialog.title.1':
    'csvファイルのインポート中にエラーが発生しました。',
  'master.ImportErrorDialog.title.2':
    'csvファイルを修正し、再インポートを実施してください。',
  'master.ImportErrorDialog.button.close': '閉じる',
};

export default masterMessages;
